import { add } from "date-fns";

import { formatDate } from "simplydo/core/dates";
import type { UiColor } from "simplydo/react/ui/utils/colors";

export const getDateStatus = (
  value: string | Date | undefined,
): { color?: UiColor; text: string; basic?: boolean } | undefined => {
  if (!value) return;
  const date = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return;

  if (date > add(new Date(), { days: 7 })) {
    return { basic: true, text: formatDate(date, "do MMM ''yy") };
  }
  if (date < new Date()) {
    return { color: "red", text: formatDate(date, "do MMM ''yy") };
  }
  return { color: "orange", text: formatDate(date, "do MMM ''yy") };
};

export const deadlineSortValue = (value?: string | Date | null) => {
  if (!value) return Number.POSITIVE_INFINITY;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? Number.POSITIVE_INFINITY : time;
};
